import styles from "./OrangeTabs.module.scss"

const OrangeTabs = ({ tabs, activeTab, setActiveTab = () => {} }) => {
  return (
    <div className={`d-flex my-3 ${styles.container}`}>
      {tabs.map((tab) => (
        <div className={`fw-semibold ${styles.tab} ${activeTab === tab ? styles.active : ""}`} onClick={() => setActiveTab(tab)} key={tab}>
          {tab}
        </div>
      ))}
    </div>
  )
}

export default OrangeTabs
